import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('GroupAnalyticsController', GroupAnalyticsController);

    function GroupAnalyticsController(
        $scope,
        $filter,
        CompanyFactory,
        CompaniesFactory,
        FormVerificationService
    ) {
        var vm = this,
            groupByName = 'Pracownik';

        $scope.groupBy = 'assigned_to';

        vm.groupList = [
            { id: 'assigned_to', name: 'Pracownik' },
            { id: 'customer', name: 'Klient' },
        ];

        function separateData(data) {
            var sepData = [];

            for (var i = 0; i < data.length; i++) {
                sepData.push(data[i].count);
            }

            return sepData;
        }

        function createLabels(data) {
            var result = [];

            for (var i = 0; i < data.length; i++) {
                result.push(data[i].name);
            }

            return result;
        }

        function combine(arr1, arr2) {
            var result = [];

            for (var i = 0; i < arr1.length; i++) {
                result.push({ count: arr1[i], name: arr2[i] });
            }

            result = $filter('orderBy')(result, 'count', true);
            return result;
        }

        $scope.$watch('[groupBy, dateFrom, dateTo, period_type]', function () {
            var params = {
                group_by: $scope.groupBy,
                date_from: $scope.dateFrom,
                date_to: $scope.dateTo,
                period: $scope.period_type,
            };

            function createTmpLabels(data) {
                var labels = [];

                if ($scope.groupBy == 'customer') {
                    groupByName = 'Klient';
                    for (var i = 0; i < data.length; i++) {
                        labels.push(data[i].customer.name);
                    }
                }

                if ($scope.groupBy == 'assigned_to') {
                    groupByName = 'Wykonawca';
                    for (var j = 0; j < data.length; j++) {
                        labels.push(data[j].company_employee.name);
                    }
                }

                return labels;
            }

            CompanyFactory.readCompany().then(function (comp_id) {
                FormVerificationService.clearErrors(vm.periodForm);
                CompaniesFactory.readIssueReportGroup(
                    comp_id.data.organization.party_uuid,
                    params
                ).then(function (response) {
                    vm.tmpChartLabels = createTmpLabels(response.data.report);
                    vm.tmpData = separateData(response.data.report);
                    vm.combinedData = combine(vm.tmpData, vm.tmpChartLabels);
                    vm.data = separateData(vm.combinedData);
                    vm.chartLabels = createLabels(vm.combinedData);
                    vm.dateFrom = response.data.date_from;
                    vm.dateTo = response.data.date_to;

                    vm.options = {
                        scales: {
                            yAxes: [
                                {
                                    scaleLabel: {
                                        display: true,
                                        labelString: 'Ilość zgłoszeń',
                                    },
                                    ticks: {
                                        beginAtZero: true,
                                        callback: function (value) {
                                            if (value % 1 === 0) {
                                                return value;
                                            }
                                        },
                                    },
                                },
                            ],
                            xAxes: [
                                {
                                    scaleLabel: {
                                        display: true,
                                        labelString: groupByName,
                                    },
                                },
                            ],
                        },
                    };
                }, function (response) {
                    FormVerificationService.error(response.data, vm.periodForm);
                });
            });
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/analytics/group-analytics/group-analytics.controller.ts